import axios from "axios";

const courseConfig = {
  headers: {
    Accept: "application/vnd.api+json",
    "Content-Type": "application/vnd.api+json",
    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    "X-CSRF-Token": localStorage.getItem("CSRF")
  }
};

const userConfig = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
    "X-CSRF-Token": localStorage.getItem("CSRF")
  }
};

const loginConfig = {
  headers: {
    "Content-Type": "application/json"
  }
};

const url = "http://uiapi.rachelmanning.com/";

class PostService {
  // Check password
  static checkUser(username, password) {
    return new Promise(function(resolve, reject) {
      axios
        .post(
          `${url}user/login?_format=json`,
          {
            name: username,
            pass: password
          },
          loginConfig
        )
        .then(function(res) {
          localStorage.setItem(
            "currentUser",
            res.data.current_user.uid
            // JSON.stringify(res.data.current_user.uid)
          );
          localStorage.setItem("jwt", res.data.access_token);
          localStorage.setItem("CSRF", res.data.csrf_token);
          resolve(function() {
            console.log("logged in");
          });

          if (localStorage.getItem("jwt") != null) {
            this.$router.push("admin");
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // Get User Info
  static getUser(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}api/user/${userId}`, userConfig)
        .then(res => {
          const data = res.data;
          resolve(
            data.map(user => ({
              ...user
            }))
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // Add Course
  static getSubjects() {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}api/subjects`, userConfig)
        .then(res => {
          const data = res.data;
          resolve(
            data.map(subject => ({
              ...subject
            }))
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  static getTopics(subject) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}api/${subject}/topics`, userConfig)
        .then(res => {
          const data = res.data;
          resolve(
            data.map(topic => ({
              ...topic
            }))
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  static getSections(topic) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}api/${topic}/sections`, userConfig)
        .then(res => {
          const data = res.data;
          resolve(
            data.map(section => ({
              ...section
            }))
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // Add course
  static insertCourse(userId, courseId) {
    return axios.post(
      `${url}jsonapi/user/user/${userId}/relationships/field_courses`,
      {
        data: [
          {
            type: "node--course_section",
            id: courseId
          }
        ]
      },
      courseConfig
    );
  }
  // Get Courses
  static getCourses(studentId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${url}api/schedule/${studentId}`, userConfig)
        .then(res => {
          const data = res.data;
          resolve(
            data.map(course => ({
              ...course
            }))
          );
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  // // Delete Course
  // static deleteCourse(id) {
  //   return axios.delete(`${url}${id}`);
  // }
}

export default PostService;



// WEBPACK FOOTER //
// ./src/PostService.js